module.exports = __webpack_public_path__ + "static/media/Cerficate.7dbcf15f.jpg";